import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useImmer } from "use-immer";

import {
  ColorError,
  IgDialog,
  IgTextField,
  IgTypography,
} from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { usePatchOrganization } from "../../api/organizations/patch-organization";
import { isDialogOpen, setDialog } from "../../store/slices/global";
import { urlRegex } from "../../utils/constants";

interface TestSaveDialogProps {}

export const SetDomainDialog: FC<TestSaveDialogProps> = () => {
  const [url, setUrl] = useImmer<string>("");
  const [error, setError] = useImmer<boolean>(false);
  const isOpen = useSelector(isDialogOpen("setDomain"));
  const dispatch = useDispatch();
  const patchOrganization = usePatchOrganization();

  const handleChange = (value: string) => {
    setUrl(value);
    if (value.length <= 8 || urlRegex.test(value)) {
      setError(false);
    } else {
      setError(true);
    }
  };

  const handleYesClick = () => {
    patchOrganization.mutate({
      body: {
        domain: url,
      },
      queryParams: undefined,
      pathParams: undefined,
    });
  };

  return (
    <IgDialog
      title={"Set Your Domain"}
      handleClose={(event: any, reason: any) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          dispatch(setDialog({ dialog: "setDomain", open: false }));
        }
      }}
      showDialog={isOpen}
      showCloseIcon={false}
      dialogContentWidth={"400px"}
      dialogHeight={null}
      maxWidth={"md"}
      loading={patchOrganization.isPending}
      handleYesClick={handleYesClick}
      yesButtonDisabled={error}
      yesButtonText={"Save"}
      noButtonText={"Later"}
      rawContent={
        <Grid container item direction={"column"} rowSpacing={1}>
          <Grid item>
            <IgTypography>
              What URL do your customers visit to view your site?
            </IgTypography>
          </Grid>
          <Grid item>
            <IgTextField
              value={url}
              onChange={(e) => handleChange(e.target.value)}
              fullWidth={true}
            />
            {error ? (
              <IgTypography color={ColorError.main} sx={{ fontSize: "13px" }}>
                Invalid URL format
              </IgTypography>
            ) : null}
          </Grid>
          <Grid item>
            <IgTypography>
              This may be changed later in the settings page.
            </IgTypography>
          </Grid>
        </Grid>
      }
    />
  );
};
